import { render } from "./WalletMethod.vue?vue&type=template&id=fa7de078&lang=pug"
import script from "./WalletMethod.vue?vue&type=script&lang=js"
export * from "./WalletMethod.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__